import { useQuery } from '@tanstack/react-query';

import {
  type RoleRecommendationDetails,
  type RoleRecommendationsListParams,
  type RoleRecommendationsListResponse,
  RoleRecommendationsService,
} from '../services';

/**
 * Hook to fetch paginated list of role recommendations
 * @param params - Query parameters for filtering and pagination
 * @returns React Query result with role recommendations data
 */
export const useRoleRecommendations = (
  params: RoleRecommendationsListParams = {}
) =>
  useQuery<RoleRecommendationsListResponse>({
    queryKey: ['roleRecommendations', params],
    queryFn: () => RoleRecommendationsService.getRoleRecommendations(params),
  });

/**
 * Hook to fetch detailed information for a specific role recommendation
 * @param recommendedObjectKey - Unique identifier for the role recommendation
 * @returns React Query result with role recommendation details
 */
export const useRoleRecommendationDetails = (recommendedObjectKey: number) =>
  useQuery<RoleRecommendationDetails>({
    queryKey: ['roleRecommendationDetails', recommendedObjectKey],
    queryFn: () =>
      RoleRecommendationsService.getRoleRecommendationDetails(
        recommendedObjectKey
      ),
    enabled: !!recommendedObjectKey,
  });
